import { Alert, Box, Button, MenuItem, Paper, Stack, TextField, Typography } from '@mui/material';
import { memo } from 'react';
import {
  PRIORITY_OPTIONS,
  SEGMENT_OPTIONS,
  SURFACE_SX,
} from './customerDetailUtils';

const CustomerDetailProfileSection = memo(function CustomerDetailProfileSection({
  error,
  formValues,
  isSaving,
  onFieldChange,
  onSubmit,
  successMessage,
}) {
  return (
    <Paper elevation={0} sx={{ ...SURFACE_SX, p: { xs: 2, md: 2.25 } }}>
      <Stack component="form" spacing={1.5} onSubmit={onSubmit}>
        <Box>
          <Typography variant="h6" fontWeight={700}>
            CRM overlay
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Save tenant-local account context here without changing Fortnox master data.
          </Typography>
        </Box>

        {error && <Alert severity="error">{error}</Alert>}
        {successMessage && <Alert severity="success">{successMessage}</Alert>}

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: 'repeat(2, minmax(0, 1fr))' },
            gap: 1.25,
          }}
        >
          <TextField
            select
            label="Priority"
            value={formValues.priority}
            onChange={onFieldChange('priority')}
            size="small"
            fullWidth
          >
            <MenuItem value="">Not set</MenuItem>
            {PRIORITY_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            label="Segment"
            value={formValues.segment}
            onChange={onFieldChange('segment')}
            size="small"
            fullWidth
          >
            <MenuItem value="">Not set</MenuItem>
            {SEGMENT_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Box>

        <TextField
          label="Buying rhythm notes"
          value={formValues.buyingRhythmNotes}
          onChange={onFieldChange('buyingRhythmNotes')}
          size="small"
          multiline
          minRows={4}
          fullWidth
        />
        <TextField
          label="Product preference notes"
          value={formValues.productPreferenceNotes}
          onChange={onFieldChange('productPreferenceNotes')}
          size="small"
          multiline
          minRows={4}
          fullWidth
        />
        <TextField
          label="Seasonality notes"
          value={formValues.seasonalityNotes}
          onChange={onFieldChange('seasonalityNotes')}
          size="small"
          multiline
          minRows={4}
          fullWidth
        />

        <Button
          type="submit"
          variant="contained"
          disabled={isSaving}
          sx={{ alignSelf: 'flex-start', textTransform: 'none' }}
        >
          {isSaving ? 'Saving...' : 'Save CRM profile'}
        </Button>
      </Stack>
    </Paper>
  );
});

export default CustomerDetailProfileSection;
